import { Button, CardContent, Card, Grid, FormControlLabel, Radio, RadioGroup, Box, Grow } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { LegendType } from "../CalculationResultOnMap";
import { useCustomLegendSchema } from "src/schemas/custom-legend.schema";
import { DecimalScaleTextField } from "../form-components/DecimalScaleTextField";

interface Props {
  legendType: LegendType;
  customMinMax: { min: number; max: number };
  onChooseDefault: () => void;
  onChooseDynamic: () => void;
  onChooseCustom: (values: { min: number; max: number }) => void;
}

export function LegendBack(props: Props) {
  const { customMinMax } = props;
  const { t } = useTranslation();
  const validationSchema = useCustomLegendSchema();

  // render the component
  return render();

  function render() {
    return (
      <Card style={{ width: "100%", height: "100%" }}>
        <CardContent style={{ backgroundColor: "#eee", width: "100%", height: "100%" }}>
          <Formik
            initialValues={{
              min: customMinMax.min,
              max: customMinMax.max,
            }}
            validationSchema={validationSchema}
            onSubmit={props.onChooseCustom}
            enableReinitialize
          >
            {({ handleSubmit }) => (
              <Form>
                <RadioGroup value={props.legendType}>
                  <FormControlLabel
                    value={LegendType.default}
                    label={t<string>("label.default")}
                    onClick={() => {
                      props.onChooseDefault();
                    }}
                    control={<Radio color="primary" size="small" />}
                  />

                  <FormControlLabel
                    value={LegendType.dynamic}
                    label={t<string>("label.dynamic")}
                    onClick={() => {
                      props.onChooseDynamic();
                    }}
                    control={<Radio color="primary" size="small" />}
                  />
                  <FormControlLabel
                    value={LegendType.minMax}
                    label={t<string>("label.custom")}
                    onClick={() => {
                      handleSubmit();
                    }}
                    control={<Radio color="primary" size="small" />}
                  />
                </RadioGroup>
                <Grow in={props.legendType === 2}>
                  <Box ml={4} sx={{ position: "relative" }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Field
                          component={DecimalScaleTextField}
                          decimalScale={2}
                          name="min"
                          label={t("label.min")}
                          type="number"
                          variant="standard"
                          disabled={false}
                          fullWidth
                          size="small"
                          inputProps={{ step: "any" }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Field
                          component={DecimalScaleTextField}
                          decimalScale={2}
                          name="max"
                          label={t("label.max")}
                          type="number"
                          variant="standard"
                          fullWidth
                          size="small"
                          disabled={false}
                          inputProps={{ step: "any" }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button type="submit" variant="outlined" color="inherit" size="small">
                          {t("label.ok")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grow>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    );
  }
}
